module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-other.svg?a38ed71cc81519a606290d0a643e5a1b";